module.exports = __webpack_public_path__ + "static/img/Frame22.d60bb1f2.png";